import React from "react";
import "./AboutUs.css";
import aboutUsImage from "../../images/aboutUsIMG.jpg";

const AboutUs = () => {
  return (
    <div className="about-us-container">
      <div className="about-us-content">
        <div className="about-us-text">
          <h2>Про нас та забуті дні народження</h2>
          <p className="about-us-description">
            Як сумління про забуті іменини в напруженому графіку породили
            сервіс, завдяки якому забути неможливо, а створити привітання легко.
          </p>
          <div className="about-us-meta">
            <span className="author">Олексій Кілочик</span>
            <span className="meta-separator">📅</span>
            <span className="date">19 вересня 2025</span>
            <span className="meta-separator">⏱️</span>
            <span className="read-time">2 хв читання</span>
          </div>
        </div>

        <img
          src={aboutUsImage}
          alt="Про нас та забуті дні народження"
          className="about-us-img"
        />
      </div>

      <div className="about-us-article">
        <p>
          Наш сервіс створений, щоб вирішити одну з буденних, але важливих
          проблем — забуті привітання. Ми поєднали технології з простим людським
          бажанням бути уважними одне до одного, підтримувати зв'язки та дружні
          контакти у свята. Тепер кожен користувач має зручний календар подій із
          автоматичними нагадуваннями та доступом до сучасних інструментів для
          яскравих привітань.
        </p>

        <p>
          Історія почалася з простої ідеї мого близького друга, однокласника
          (якого я до речі також забув привітати) — робити персоналізовані
          листівки на замовлення. Та ми пішли далі і вирішили автоматизувати
          процес та дати вам можливість творити власноруч дуже просто та швидко
          щоб у сучасному ритмі життя Ви встигли бути оригінальним та уважним до
          свого оточення. Так народився комплексний сервіс: календар,
          нагадування, вітальні листівки, ідеї привітань, а згодом очікуйте і
          нові можливості.
        </p>

        <p>
          Ми подбали, щоб користуватися сервісом було максимально легко. Жодних
          складних налаштувань чи зайвих кроків — у кілька кліків ви додаєте
          подію, створюєте листівку або текст привітання, і все готово. Ми
          прагнемо, щоб навіть у найнапруженіші дні вам вистачало кількох
          хвилин, аби не втрачати контакт із людьми, з якими приємно
          підтримувати стосунки — хай то старі друзі чи корисні знайомства та
          однодумці, колеги, нові знайомі або далекі чи близькі родичі для яких
          важко підібрати слова.
        </p>
      </div>
    </div>
  );
};

export default AboutUs;
